import  { forwardRef } from 'react'
import { Dialog, DialogContent, DialogTitle, Typography, Slide, IconButton, Box } from '@mui/material'
import { Close } from '@mui/icons-material';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PreviewNewsletter = ({ subject, body, open, onClose }) => {
  
  return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        slots={{ transition: Transition }}
        keepMounted
        aria-labelledby="alert-dialog-slide-title"
        role="dialog"
        aria-hidden={!open}
        aria-describedby="alert-dialog-slide-description"
        hideBackdrop
      >
        <DialogTitle>Preview</DialogTitle>
        <IconButton sx={{ position: 'absolute', right: 8, top: 8 }} onClick={onClose}>
          <Close />
        </IconButton>

        <DialogContent>
          <Typography variant="body1">Subject: {subject}</Typography>
          <Box sx={{ width: '100%', maxWidth: '900px', margin: '0 auto', p: 2 }}>
            <div dangerouslySetInnerHTML={{ __html: body || "<p>No content available</p>" }} />
          </Box>

        </DialogContent>
      </Dialog>
  )
}

export default PreviewNewsletter

